<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="Quel montant souhaitez-vous racheter de façon programmée ?"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      [formControlName]="keys.amount"
                      type="number"
                      placeholder="Exemple : 500 € / mois"
                      min="0"
                      fraction="2"
                    />
                    <i>€</i>
                  </pr-input-column>
                </div>
              </div>
              @if (contractTotal > 0) {
                <info [option]="optionInfo">
                  La valorisation du portefeuille est de
                  {{ contractTotal | number: '1.2-2' }} €.
                </info>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer
    (prev)="prev()"
    (next)="onSubmit()"
    [disabledNext]="form.invalid"
  ></form-footer>
</form>
